import { render, staticRenderFns } from "./PromotionalFreeSpinsCounter.vue?vue&type=template&id=10c08956&scoped=true&"
import script from "./PromotionalFreeSpinsCounter.vue?vue&type=script&lang=ts&"
export * from "./PromotionalFreeSpinsCounter.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionalFreeSpinsCounter.vue?vue&type=style&index=0&id=10c08956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c08956",
  null
  
)

export default component.exports